import type { QueryClient } from "@tanstack/react-query";

export interface EvalStewardItemRef {
  workspaceId: string;
  threadId: string;
  assistantMessageIndex: number;
}

export function invalidateEvalStewardQueries(
  queryClient: QueryClient,
  itemRef: EvalStewardItemRef,
  annotationId?: string,
): void {
  const { workspaceId, threadId, assistantMessageIndex } = itemRef;

  queryClient.invalidateQueries({
    queryKey: [
      "evalSteward",
      "feedbackTrace",
      workspaceId,
      threadId,
      assistantMessageIndex,
    ],
  });
  queryClient.invalidateQueries({
    queryKey: ["evalSteward", "feedbackItems"],
  });
  queryClient.invalidateQueries({
    queryKey: [
      "evalSteward",
      "annotationHistory",
      workspaceId,
      threadId,
      assistantMessageIndex,
    ],
  });

  if (annotationId) {
    queryClient.invalidateQueries({
      queryKey: ["evalSteward", "evalAnnotation", workspaceId, annotationId],
    });
  }
}
